/**
 * A VEVOSZOLGALATI MOD hivas-iranyitasa (docs/20-vevoszolgalat.html).
 *
 * Vevoszolgalati modban es nyitott lebego panelnel a hivas NEM kulon ablakban nyilik,
 * hanem a fo ablakban fut (a panel csak ugy fer hozza a hivas allapotahoz), es a
 * csorgest is a panel mutatja. Az `openHuddleWindow` ezert eloszor megkerdezi ezt a
 * kezelot: ha elintezte (`true`), nem nyit uj ablakot.
 *
 * A kezelot a fo ablak `ServiceHost`-ja regisztralja, amig a mod be van kapcsolva ES a
 * lebego panel nyitva van - kulonben a megszokott ut (kulon ablak, ertesites) marad.
 */

export interface ServiceCallRequest {
  channelId: string;
  /** Bejovo hivas: csorog, es a panel megvarja a dontest. */
  incoming?: boolean;
}

type ServiceCallHandler = (request: ServiceCallRequest) => boolean;

let handler: ServiceCallHandler | null = null;

export function setServiceCallHandler(next: ServiceCallHandler | null): void {
  handler = next;
}

/** Elintezte a vevoszolgalati mod? (`false`: a megszokott ut fut tovabb.) */
export function handleServiceCall(request: ServiceCallRequest): boolean {
  return handler ? handler(request) : false;
}

/**
 * A TELJES HIVASFELULET a fo ablakban (vevoszolgalati mod): a "bezaras" ott a felulet
 * visszacsukasa, NEM az ablak bezarasa - egy telepitett PWA-ban a `window.close()`
 * a fo AVSlack-ablakot zarna be.
 */
let viewCloser: (() => void) | null = null;

export function setServiceView(closer: (() => void) | null): void {
  viewCloser = closer;
}

/** Ha a teljes felulet nyitva van, visszacsukja, es `true`-t ad (a hivo ne zarjon ablakot). */
export function closeServiceView(): boolean {
  if (!viewCloser) return false;
  viewCloser();
  return true;
}

/** Aktiv-e a kezelo - ilyenkor a panel jelez, a rendszer-ertesites felesleges. */
export function serviceHandlesCalls(): boolean {
  return handler !== null;
}
